import * as React from 'react';
import { Container, Logo, Title, TitleWrap } from './header.styles';

interface Props {
  userName: string;
}

export class Header extends React.Component<Props, {}> {
  public render() {
    return (
      <Container background={require('../../../../assets/img/header.jpg')}>
        <Logo src={require('../../../../assets/img/logo.png')}/>
        <TitleWrap>
          <Title>Welcome, {this.props.userName}!</Title>
        </TitleWrap>
      </Container>
    );
  }
}
